import React, { useState } from "react";
import "./Campus.css";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";
import FormField from "../../Components/FormField/FormField";
import Modal from "../../Components/Modal/Modal";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import { notify } from "react-notify-toast";
import ConfirmPasswordPopup from "../Account/ConfirmPasswordPopup";
import {
  getPermissionList,
  firstHalfIndex,
  secondHalfIndex,
  getPermissionSize,
  permIndices,
} from "../../Permissions";
import { Placeholder } from "semantic-ui-react";

class personnel2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowing: false,
      personnel: props.personnel,
      current_index: props.current_index,
      current_personnel: "",
      campuses: [],
      activecampuses: [],
      permissions: 0,
      showTransferModal: false,
      permissionlist: getPermissionList(),
      allPermissions: (1 << getPermissionSize()) - 1,
      original_email: props.personnel[props.current_index].personnel_email,
      fullcontrol: false,
      edited: false,
      access_permission: {}
    };
  }

  toggleTransferModal = (e) => {
    // setTransferModal(!showTransferModal);
    if (this.state.showTransferModal) {
      this.setState({ showTransferModal: false });
    } else {
      this.setState({ showTransferModal: true });
    }
  };

  openModal = (e) => {
    this.setState({ isShowing: true });
  };
  closeModal = (e) => {
    this.setState({ isShowing: false });
  };

  swapTab = (personnel, index) => {
    localStorage.setItem("personnel-Index", index);
    this.setState({
      personnel: personnel,
      current_index: index,
      current_personnel: personnel[index],
      permissions: personnel[index].permissions,
      original_email: personnel[index].personnel_email,
      access_permission: personnel[index].access_permission || {}
    });
  };

  handlePermissions = (e) => {
    this.setState({ edited: true });
    var perms = this.state.permissions;
    var value = e.target.value;
    // console.log("change: ", e.target.checked, e.target.value, e.target.title)
    this.setState({
      access_permission: {
        ...this.state.access_permission,
        [e.target.title]: e.target.checked
      }
    })
    // if (e.target.checked) {
    //   perms =
    //     value == 1 << permIndices.ed_book
    //       ? perms | ((1 << permIndices.ed_book) + (1 << permIndices.vi_book))
    //       : perms | value;
    //   perms =
    //     value == 1 << permIndices.ed_lst
    //       ? perms | ((1 << permIndices.ed_lst) + (1 << permIndices.vi_lst))
    //       : perms | value;
    //   this.setState({ permissions: perms });
    // } else {
    //   perms =
    //     value == 1 << permIndices.vi_book
    //       ? perms &
    //         (this.state.allPermissions -
    //           (1 << permIndices.ed_book) -
    //           (1 << permIndices.vi_book))
    //       : value == 1 << permIndices.vi_lst
    //       ? perms &
    //         (this.state.allPermissions -
    //           (1 << permIndices.ed_lst) -
    //           (1 << permIndices.vi_lst))
    //       : perms & (this.state.allPermissions - value);
    //   this.setState({ permissions: perms });
    // }
  };

  componentDidMount = () => {
    if (this.props.mobilePer) {
      this.setState({
        personnel: this.props.personnel,
        current_personnel: this.props.mobilePer,
        campuses: this.props.campuses,
        activecampuses: this.props.user.campuses,
        permissions: this.props.mobilePer.permissions,
        fullcontrol: this.props.user.permissions ? false : true,
        access_permission: this.props.user.access_permission || {}
      });
    } else {
      console.log(
        this.props.current_index,
        localStorage.getItem("personnel-Index")
      );
      var index = this.props.current_index;
      if (localStorage.getItem("personnel-Index") != null && !this.props.isViewAsAdmin) {
        index = parseInt(localStorage.getItem("personnel-Index"));
      }
      // console.log("index", index)

      this.setState({
        personnel: this.props.personnel,
        current_index: index,
        current_personnel: this.props.personnel[index],
        campuses: this.props.campuses,
        activecampuses: this.props.user.campuses,
        permissions: this.props.personnel[index].permissions,
        fullcontrol: this.props.user.permissions ? false : true,
        access_permission: this.props.personnel[index].access_permission || {}
      });
    }
  };

  handleDepartChange = (e) => {
    this.setState({ edited: true });
    var original_per = this.state.current_personnel;
    if (original_per.personnel_departments.includes(e.target.value)) {
      original_per.personnel_departments.splice(
        original_per.personnel_departments.indexOf(e.target.value),
        1
      );
    } else {
      original_per.personnel_departments.push(e.target.value);
    }
    this.setState({
      current_personnel: original_per,
    });
  };

  handleCmmChange = (e) => {
    this.setState({ edited: true });
    var original_per = this.state.current_personnel;
    if (original_per[`${e.target.value}`]) {
      original_per[`${e.target.value}`] = false;
    } else {
      original_per[`${e.target.value}`] = true;
    }
    this.setState({
      current_personnel: original_per,
    });
  };

  handleRefChange = (e) => {
    this.setState({ edited: true });
    var original_per = this.state.current_personnel;
    original_per.reference_name = e.target.value;
    this.setState({
      current_personnel: original_per,
    });
  };

  handleFieldsChange = (e) => {
    this.setState({ edited: true });
    var original_per = this.state.current_personnel;
    original_per[`${e.target.id}`] = e.target.value;
    this.setState({
      current_personnel: original_per,
    });
  };

  validateMobileNumber(number) {
    let isValid = false;
    if (number && number.length === 10 && number.substring(0, 2) === "04") {
      isValid = true;
    }
    return isValid;
  }

  handleSubmit = (e) => {
    // console.log("submit", this.state.current_personnel)
    e.preventDefault();
    const fields = [
      // "personnel_mobile",
      "personnel_email",
      "personnel_role",
      "personnel_last_name",
      "personnel_first_name",
    ];
    let errors = false;

    for (let field of fields) {
      const input = document.getElementById(field);
      if (!input.reportValidity()) {
        errors = true;
        break;
      }
    }

    /*
    if (
      !this.validateMobileNumber(this.state.current_personnel.personnel_mobile)
    ) {
      notify.show(
        "Please enter an Australian mobile number, eg: 04XXXXXXXX (10 Digit)",
        "error"
      );
      errors = true;
    }
     */

    if (!this.props.user?.is_childcare_centre && this.state.current_personnel.personnel_departments.length === 0) {
      notify.show("Please add at least one delivered department");
      errors = true;
    }

    if (this.state.current_personnel.campuses.length === 0) {
      notify.show("Please add at least one campus");
      errors = true;
    }

    if (this.state.current_personnel.reference_name.length > 7) {
      notify.show("Nickname max 7 characters");
      errors = true;
    }

    if (
      this.state.current_personnel.personnel_email.toLowerCase() ===
      this.props.user.email.toLowerCase()
    ) {
      notify.show(
        "This area is for adding your team members. Account owners should not duplicate their credentials here."
      );
      errors = true;
    }

    const dup_email = this.state.personnel.filter((ele) => {
      return (
        ele.personnel_email.toLowerCase() ===
        this.state.current_personnel.personnel_email.toLowerCase()
      );
    });
    // '>1' because the filter will always return the current personnel, but if it returns 2 personnels with the same email, then some exisitng personnel is sharing the same email
    if (dup_email.length > 1) {
      notify.show(
        `You have added the email to Personnel: ${dup_email[0].reference_name}.`
      );
      errors = true;
    }

    const dup_nickname = this.state.personnel.filter((ele) => {
      return ele.reference_name === this.state.current_personnel.reference_name;
    });
    // '>1' because the filter will always return the current personnel, but if it returns 2 personnels with the same email, then some exisitng personnel is sharing the same email
    if (dup_nickname.length > 1) {
      notify.show(
        `You have added the same nickname to another personnel: ${dup_nickname[0].reference_name}.`
      );
      errors = true;
    }

    if (!errors) {
      const current_personnel = this.state.current_personnel;
      if (current_personnel.personnel_email !== this.state.original_email) {
        current_personnel.email_verification_status = false;
      }
      this.props.handleSubmit(current_personnel, this.state.access_permission);
      //window.location.reload(false)
    }
  };

  handleCampusesChange = (e) => {
    this.setState({ edited: true });
    var original_per = this.state.current_personnel;
    if (original_per.campuses.includes(e.target.id)) {
      original_per.campuses.splice(
        original_per.campuses.indexOf(e.target.id),
        1
      );
    } else {
      original_per.campuses.push(e.target.id);
    }
    this.setState({
      current_personnel: original_per,
    });
  };

  handleDelete = (e) => {
    localStorage.setItem("personnel-Index", 0);
    this.props.handleDelete(this.state.current_personnel);
    //window.location.reload(false)
  };

  // onConfirm = () => {
  //   console.log("yip!!")
  // }

  render() {
    // Logic for determing whether to show verification element.
    let verified;
    if (this.state.original_email === "") {
      verified = null;
    } else if (this.state.current_personnel.email_verification_status) {
      verified = <p>"User Verified"</p>;
    } else {
      verified = <p>"Re-Send Verification Link"</p>;
    }
    // console.log("showTransferModal: ", this.state.showTransferModal)
    return (
      <div className="row college-info">
        <div className="col-lg-6 col-md-12 column-fix">
          <div className="w-100 row flex-row">
            <FormField
              label="First name"
              id="personnel_first_name"
              header={
                <HoverIcon
                  icon="info circle"
                  color="grey"
                  text="Enter manager's name Not your name"
                />
              }
              className="col-md-6 column-fix"
              required
              value={this.state.current_personnel.personnel_first_name}
              onChange={this.handleFieldsChange}
              placeholder="First name"
            />
            <FormField
              label="Last name"
              id="personnel_last_name"
              className="col-md-6 column-fix"
              required
              value={this.state.current_personnel.personnel_last_name}
              onChange={this.handleFieldsChange}
              placeholder="Last name"
            />
          </div>

          <div className="w-100 row flex-row">
            <div className="col-md-12 column-fix">
              <FormField
                label="Role title"
                id="personnel_role"
                value={this.state.current_personnel.personnel_role}
                onChange={this.handleFieldsChange}
                placeholder="Role title"
                required
              />
            </div>
          </div>

          <div className="w-100 row flex-row">
            <div className="col-md-12 column-fix">
              <FormField
                icon="account-check"
                label="Email address"
                // id="manager_email"
                id="personnel_email"
                type="email"
                value={this.state.current_personnel.personnel_email}
                onChange={this.handleFieldsChange}
                disabled={
                  this.state.current_personnel.email_verification_status
                }
                // pattern="^([a-zA-Z0-9_\-\.])+@(([A-Za-z0-9_\-\.])+(.edu.au))$"
                //pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.+-]+\.edu(?:\.\w{2,3})?$"
                title="Please register with institution email"
                autoFocus
                placeholder="name@xxx.edu.au"
                required
              />
            </div>
          </div>

          <div className={this.props.isViewAsAdmin ? "w-100 row flex-row" : "d-none"}>
            <div className="col-md-12 column-fix">
              <FormField
                icon="phone"
                label="Phone number"
                // id="phoneNo"
                id="personnel_mobile"
                required
                value={this.state.current_personnel.personnel_mobile}
                // type="number"
                // value={this.props.state.phoneNo}
                onChange={this.handleFieldsChange}
                // disabled={this.props.state.phoneNo_verified}
                placeholder="Phone Number"
              />
            </div>
          </div>

          <ButtonContainer
            label={this.props.user.is_childcare_centre ? "Centre/s they work at" : "Campus/es they work at"}
            className="w-100 row flex-row"
            header={
              <HoverIcon
                icon="info circle"
                color="grey"
                text={this.props.user.is_childcare_centre ? "Navigate to Centre Tab to set up centre" : "Navigate to Campus Tab to set up campus"}
              />
            }
          >
            <div className="col-md-12 column-fix">
              {this.state.campuses.length == 0 ? (
                <p></p>
              ) : (
                this.state.campuses
                  .filter((campus) => {
                    return campus.address_line1.length > 0;
                  })
                  .map((campus) => {
                    const checkable =
                      this.state.fullcontrol ||
                      this.state.activecampuses.filter((item) => {
                        return item === campus._id;
                      }).length > 0;
                    return (
                      <CheckableButton
                        checkbox
                        id={campus._id}
                        className="campus-departments-checkbox"
                        title={campus._id}
                        key={campus._id}
                        onChange={this.handleCampusesChange}
                        checked={
                          this.state.current_personnel &&
                          this.state.current_personnel.campuses &&
                          this.state.current_personnel.campuses.includes(
                            campus._id
                          )
                        }
                        disabled={!checkable}
                      >
                        {`${campus.address_line1}, ${campus?.address_line2 ? campus?.address_line2 + ", " : ''}${campus.suburb}`}
                      </CheckableButton>
                    );
                  })
              )}
            </div>
          </ButtonContainer>

          {
            !this.props.user?.is_childcare_centre && (
              <ButtonContainer
                label="Department/s of Responsibilty"
                className="w-100 row flex-row"
              >
                <div className="col-md-4 column-fix pr-2">
                  <CheckableButton
                    checkbox
                    id="departments-elicos"
                    value="ELICOS"
                    name="departments"
                    onChange={this.handleDepartChange}
                    checked={
                      !this.state.current_personnel.personnel_departments
                        ? false
                        : this.state.current_personnel.personnel_departments.includes(
                            "ELICOS"
                          )
                    }
                    title="ELICOS"
                  >
                    ELICOS
                  </CheckableButton>
                </div>
                <div className="col-md-4 column-fix px-2">
                  <CheckableButton
                    checkbox
                    id="departments-vet"
                    name="departments-delivered"
                    value="VET"
                    title="VET"
                    onChange={this.handleDepartChange}
                    checked={
                      !this.state.current_personnel.personnel_departments
                        ? false
                        : this.state.current_personnel.personnel_departments.includes(
                            "VET"
                          )
                    }
                  >
                    VET
                  </CheckableButton>
                </div>
                <div className="col-md-4 column-fix pl-2">
                  <CheckableButton
                    checkbox
                    id="departments-vet-other"
                    name="departments-delivered"
                    title="VET Other"
                    value="VETO"
                    onChange={this.handleDepartChange}
                    checked={
                      !this.state.current_personnel.personnel_departments
                        ? false
                        : this.state.current_personnel.personnel_departments.includes(
                            "VETO"
                          )
                    }
                  >
                    VET Other
                  </CheckableButton>
                </div>
              </ButtonContainer>
            )
          }
        </div>

        <div className="col-lg-6 col-md-12 column-fix">
          <ButtonContainer
            label="Permissions (Select Multiple)"
            className="w-100 row flex-row"
          >
            <div className="col-md-12 column-fix">
              <CheckableButton
                toggle
                id="permission"
                name="permission"
                title="manage_payment"
                value={this.state.access_permission.manage_payment}
                checked={this.state.access_permission.manage_payment}
                onClick={this.handlePermissions}
              >
                Approves invoice 
              </CheckableButton>
            </div>
            <div className="col-md-12 column-fix">
              <CheckableButton
                toggle
                id="permission"
                name="permission"
                title="receives_invoice_copy"
                value={this.state.access_permission.receives_invoice_copy}
                checked={this.state.access_permission.receives_invoice_copy}
                onClick={this.handlePermissions}
              >
                Receives invoice copy
              </CheckableButton>
            </div>
            {/* <div className="col-md-6 column-fix">
              {firstHalfIndex().map((index) => {
                return (
                  <CheckableButton
                    toggle
                    id="permissions"
                    name="permissions"
                    title={this.state.permissionlist[index]}
                    value={1 << index}
                    checked={this.state.permissions & (1 << index)}
                    onClick={this.handlePermissions}
                  >
                    {this.state.permissionlist[index]}
                  </CheckableButton>
                );
              })}
            </div>
            <div className="col-md-6 column-fix">
              {secondHalfIndex().map((index) => {
                return (
                  <CheckableButton
                    toggle
                    id="permissions"
                    name="permissions"
                    title={this.state.permissionlist[index]}
                    value={1 << index}
                    checked={this.state.permissions & (1 << index)}
                    onClick={this.handlePermissions}
                  >
                    {this.state.permissionlist[index]}
                  </CheckableButton>
                );
              })}
            </div> */}
          </ButtonContainer>

          <ButtonContainer
            label="Communication settings"
            className="w-100 row flex-row"
          >
            <div className="col-md-12 column-fix">
              <CheckableButton
                toggle
                id="receive_email"
                name="com_setting"
                onChange={this.handleCmmChange}
                checked={this.state.current_personnel.get_booking_email == true}
                title="receive_email"
                value="get_booking_email"
              >
                Receive booking email
              </CheckableButton>
            </div>
            <div className="col-md-12 column-fix">
              <CheckableButton
                className='d-none'
                toggle
                id="book_online"
                name="com_setting"
                onChange={this.handleCmmChange}
                checked={this.state.current_personnel.make_booking_plat == true}
                title="book_online"
                value="make_booking_plat"
              >
                Make booking online
              </CheckableButton>
              <CheckableButton
                className='d-none'
                toggle
                id="book_sms"
                name="com_setting"
                onChange={this.handleCmmChange}
                checked={this.state.current_personnel.make_booking_sms == true}
                title="book_sms"
                value="make_booking_sms"
              >
                Make booking via SMS
              </CheckableButton>
            </div>
          </ButtonContainer>

          {/*<div className="w-100 row flex-row">*/}
          {/*<div className="col-md-6">*/}
          {/*<ConfirmButton*/}
          {/*type="submit"*/}
          {/*className="transfer_account_ownership"*/}
          {/*// onClick={this.handleSubmit}*/}
          {/*>*/}
          {/*Transfer account ownership*/}
          {/*</ConfirmButton>*/}
          {/*</div>*/}
          {/*</div>*/}

          <div className="w-100 row flex-row">
            <div className="col-md-6 column-fix">
              <FormField
                // id="man_shortname"
                id="reference_name"
                label={this.props.user?.is_childcare_centre ? "Save personnel under a nickname" : "Save manager under a nickname"}
                placeholder="E.g.: Alex (max 7 characters)"
                value={
                  this.state.current_personnel.reference_name == "unnamed"
                    ? Placeholder
                    : this.state.current_personnel.reference_name
                }
                onChange={this.handleRefChange}
                maxLength={7}
                required
                style={{"margin": "20px"}}
              ></FormField>
            </div>
            <div className="col-md-6 d-flex flex-column justify-content-end column-fix">
              {/*<div style={{height:"25px"}}>&nbsp;</div>*/}
              <div>&nbsp;</div>
              <CancelButton
                // type="submit"
                className="transfer_account_ownership mb-3"
                onClick={this.toggleTransferModal}
                hidden={!this.props.transfer_ownner}
              >
                Transfer account ownership
              </CancelButton>

              <ConfirmPasswordPopup
                header="Transfer Account ownership"
                show={this.state.showTransferModal}
                onClose={this.toggleTransferModal}
                role="teacher"
                onConfirm={this.onConfirm}
              >
                Warning: this action cannot be undone!
              </ConfirmPasswordPopup>
            </div>
          </div>
        </div>

        <div className="row col-md-12 pt-6 column-fix">
          {/* {verified} */}
          <div className="col-md-6 pr-md-3 column-fix">
            <CancelButton
              type="button"
              className="college_delete"
              hidden={!this.props.editpersonnel}
              //disabled
              onClick={this.openModal}
            >
              Delete
            </CancelButton>
          </div>

          <div className="col-md-6 pl-md-3 column-fix">
            <ConfirmButton
              type="submit"
              className="college_submit"
              hidden={!this.props.editpersonnel}
              disabled={!this.state.edited}
              onClick={this.handleSubmit}
            >
              Submit
            </ConfirmButton>
          </div>
        </div>
        <Modal
          className="confirm-delete"
          header="Do you wish to delete?"
          show={this.state.isShowing}
          onClose={this.closeModal}
        >
          <div className="row m-0">
            <div className="col-md-6">
              <CancelButton type="button" onClick={this.closeModal}>
                Cancel
              </CancelButton>
            </div>
            <div className="col-md-6 padding-for-mobile">
              <ConfirmButton type="button" onClick={this.handleDelete}>
                Yes and Proceed
              </ConfirmButton>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default personnel2;
